// BasketContext.js
import React, { createContext, useState, useEffect } from 'react';

export const BasketContext = createContext({
  basket: !localStorage.getItem("LocalBasket") ? [] : JSON.parse(localStorage.getItem("LocalBasket")),
  setBasket: () => { },
});
export const BasketProvider = ({ children }) => {
  const [basket, setBasket] = useState(() => {
    const stored = localStorage.getItem("LocalBasket");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    localStorage.setItem('LocalBasket', JSON.stringify(basket));

    // Optional: Listen for changes from other tabs
    const handleStorageChange = (e) => {
      if (e.key === 'LocalBasket') {
        setBasket(JSON.parse(e.newValue));
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [basket]);

  const updateLocalBasket = (newBasket) => {
    localStorage.setItem('LocalBasket', JSON.stringify(newBasket));
  };

  return (
    <BasketContext.Provider value={{ basket, setBasket, updateLocalBasket }}>
      {children}
    </BasketContext.Provider>
  );
};
